"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThreshold",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThreshold",
                type: "uint256",
            },
        ],
        name: "_setProposalThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOLogicV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV1__factory = NounsDAOLogicV1__factory;
NounsDAOLogicV1__factory.bytecode = _bytecode;
NounsDAOLogicV1__factory.abi = _abi;
